import {
  ASSIGNMENT_ACTIVITY_LIST,
  GET_ACTIVITY_ASSIGNMENT,
  EMBEDDED_ASSIGNMENT_ACTIVITY_LIST,
  GET_ACTIVITY_ASSIGNMENT_BY_CONFIGURATION_ID,
} from "../constants";
import axios from "axios";
import { ApiCall } from "../../utils/index"

export const getAssignmentActivityList =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token},
      } = getState();
      const result = await ApiCall.get(`/activity/allwith/customfields`, token);
      dispatch({ type: ASSIGNMENT_ACTIVITY_LIST, payload: result.data });
      if(request.onSuccess) {
        request.onSuccess(result.data)
      }
    } catch (error) {
      request.onError();
    }
  };

export const getAssignmentData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token, company },
    } = getState();
    const result = await ApiCall.get(`/activityAssignment/byId/${request.assignmentID}`, token);
    dispatch({ type: GET_ACTIVITY_ASSIGNMENT, payload: result.data });
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

export const createUpdateActivityAssignmentMapping =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token, company },
      } = getState();
      const result = await ApiCall.post("/activityAssignmentMapping/bulk", request.payloadArr, token);

      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

export const handelDeleteAssignmentMappingData =
  (request) => async (dispatch, getState) => {
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_API_URL}/activityAssignmentMapping/${request.assignmentMappingID}`
      );
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

// Actions for activity assignment embedded screen

export const getEmbeddedAssignmentActivityList =
  (request) => async (dispatch) => {
    try {
      const result = await ApiCall.get(`/activity/embedded/allwith/customfields/${request.company_id}`);
      dispatch({
        type: EMBEDDED_ASSIGNMENT_ACTIVITY_LIST,
        payload: result.data,
      });
    } catch (error) {
      request.onError();
    }
  };

export const deleteAssignmentById =
  (assignmentid, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.delete(`/activityAssignment/${assignmentid}`, token);
      cb(result);
    } catch (err) {
      cb(err);
    }
  };
export const getAssignmentDataByConfigurationId =
  (request) => async (dispatch) => {
    try {
      const result = await ApiCall.get(`/configurationsSettingMapping/activities/${request.configurationId}`);
      dispatch({
        type: GET_ACTIVITY_ASSIGNMENT_BY_CONFIGURATION_ID,
        payload: result.data,
      });
      request.onSuccess(result.data);
    } catch (error) {
      request.onError();
    }
  };
